// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__eLsUQ","colMaxWidth":"Table_colMaxWidth__3q98p"};